module.exports = {
  NEW: 'new',
  REJECTED: 'rejected',
  RESOLVED: 'resolved',
};
